// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filterStyles } from "@insite/content-library/Widgets/MyLists/MyListsFilter";
import myAccountFilterSectionStyles from "@keller/App/SharedStyle/MyAccount/List/MyAccountFilterSectionStyles";
import { mergeWithCss, xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

filterStyles.container = {
    ...mergeWithCss(myAccountFilterSectionStyles.searchFormStyles.wrapper, {
        css: css`
            margin-top: 0;
            &:before {
                content: none;
            }
        `,
    }),
};

filterStyles.heading = {
    ...myAccountFilterSectionStyles.searchFormStyles.headingText,
};

filterStyles.fromGridItem = {
    width: [12, 6, 3, 3, 2],
    css: css`
        > div {
            display: flex;
            width: 100%;
        }
        ${xScreen("lte", "xs")} {
            padding: 15px 15px 0px;
        }
    `,
};

filterStyles.toGridItem = {
    width: [12, 6, 3, 3, 2],
    css: css`
        padding-left: 0;
        > div {
            display: flex;
            width: 100%;
        }
        ${xScreen("lte", "xs")} {
            padding: 0px 15px 15px;
        }
    `,
};

filterStyles.toDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
            margin-top: 21px;
        `,
    },
};
